import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { GalleryEditor } from "@/components/admin/GalleryEditor";

export const Route = createFileRoute("/admin/gallery")({
  component: GalleryPage,
  head: () => ({
    meta: [
      { title: "Gallery Management — Admin" },
      { name: "description", content: "Manage event photo gallery" },
    ],
  }),
});

function GalleryPage() {
  return (
    <AdminLayout>
      <GalleryEditor />
    </AdminLayout>
  );
}
